module.exports = __webpack_public_path__ + "img/4264b9b.png";